<component class="kr-button-animation" :is="component" :class="dynamicClasses"></component>